const _ = require('lodash');
const videoBgOrderIssue = require('ub/data/pom-metrics/video-bg-order-issue');

const _metricsGenerators = [
  videoBgOrderIssue
];

const getGeneratedMetrics = (pom) => _.map(module.exports._metricsGenerators, (fn) => fn(pom));

const submitMetrics = (metrics, sendMetric) => {
  _.chain(metrics)
    .flatten()
    .compact()
    .each(sendMetric)
    .value();
};

const _run = (pom, sendMetric) => {
  const metrics = getGeneratedMetrics(pom);

  submitMetrics(metrics, sendMetric);
};

// if the errorNotifier wasn't attached to window, then you wouldnt have to pass it
//   in to make this code testable.
const run = (pom, sendMetric) => setTimeout(() => _run(pom, sendMetric), 1000);

module.exports = {
  _metricsGenerators,
  _run,
  run
};



// WEBPACK FOOTER //
// ./src/data/pom-metrics/pom-metrics.js